import { Component } from '@angular/core';
import { CmpsDialogRef } from '@cmps/ng-uikit';

import { TranslationKeyMap } from './info-dialog.component.i18n';

@Component({
    selector: 'cmps-wp-info-dialog',
    templateUrl: './info-dialog.component.html',
})
export class InfoDialogComponent {
    /** @private */
    _i18n = TranslationKeyMap;

    constructor(
        /** @private */ readonly _dialogRef: CmpsDialogRef<
            InfoDialogComponent,
            void
        >,
    ) {}
}
